<template>
  <div class="pg-scan-area-form">
    <PgForm
      class="pg-scan-area-form-form"
      :class="{ 'pg-scan-area-form-form--medium': formSize === 'medium' }"
      ref="formRef"
      :extendCompileData="extendData"
      :model="formData"
      :formItems="customFormItems"
      :formItemsCode="formItemsCode"
    ></PgForm>
    <div class="pg-scan-area-form-operation">
      <slot></slot>
      <img
        :class="{ 'pg-scan-area-form-autoConfim__disabled': autoConfim }"
        class="scan-img"
        src="../../../static/image/scanSave.png"
      />
      <div class="pg-scan-area-form-operation-button">
        <ElButton type="danger" round @click="reset">重置</ElButton>
        <ElButton style="width: 90px" type="primary" round @click="confirm">确认</ElButton>
      </div>
    </div>
  </div>
</template>
<script setup>
import { PgForm } from '../../form/index'
import { ref } from 'vue'
defineProps({
  formSize: String,
  extendData: Object,
  formData: Object,
  customFormItems: Object,
  formItemsCode: String,
  autoConfim: Boolean,
  reset: Function,
  confirm: Function,
})

const formRef = ref(null)
defineExpose({
  validate: () => formRef.value.validate(),
})
</script>
<style lang="scss">
.pg-scan-area-form {
  display: flex;
  .pg-scan-area-form-form {
    width: calc(100% - 240px);
    padding-right: 10px;
    flex: 1 auto;
    .el-form-item--small.el-form-item {
      padding-left: 10px;
      margin-bottom: 6px;
    }
  }
  .pg-scan-area-form-form.pg-scan-area-form-form--medium {
    .el-form-item--small.el-form-item {
      padding-left: 18px;
      margin-bottom: 15px;
    }
  }
  .pg-scan-area-form-operation {
    width: 240px;
    padding-left: 12px;
    img {
      width: 100%;
    }
    .pg-scan-area-form-autoConfim__disabled {
      opacity: 0.5;
    }
    .pg-scan-area-form-operation-button {
      display: flex;
      justify-content: center;
      padding-top: 10px;
    }
  }
}
</style>
